import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.accountsList}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On fetching accounts:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* deleteReq(action) {
    try {
        const { account } = action.payload;
        const url = `${config.api.paths.deleteUser}`;
        yield call(http.authorized.post, url, account);
        yield put(actionCreators.deleteSuccess());
    } catch (error) {
        logToSentry("On deleting accounts:", { error });
        yield put(actionCreators.deleteFailure(error));
    }
}

function* post(action) {
    const { accounts } = action.payload;
    const { userOrganisations } = yield select((state) => state);
    const url = config.api.paths.createAccounts;
    try {
        const { data } = yield call(
            http.authorized.post,
            url,
            accounts.map((item) => ({
                ...item,
                organisation: userOrganisations.item.id
            }))
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On creating accounts:", { error });
        console.error(error);
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.ACCOUNTS_GET_REQUEST, get),
        takeLatest(actionTypes.ACCOUNTS_DELETE_REQUEST, deleteReq),
        takeLatest(actionTypes.ACCOUNTS_POST_REQUEST, post)
    ]);
}
